import Text from '../main/Text';
import { IAddress } from '../../interfaces';

function Address({ team, city, street, houseNumber, zip } : IAddress)
{
    return (
        <div style = {{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
            <Text
                text = {team}
                fontSize = {16}
                fontWeight = {700}
            />

            <Text text = {street + ' ' + houseNumber} lineHeight = '20px' />

            <Text text = {zip + ' ' + city} lineHeight = '20px' />
        </div>
    )
}

export default Address